import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';

export async function isOrganizationMember(organizationId: string, userId: string): Promise<boolean> {
  try {
    const membersQuery = query(
      collection(db, 'organizationMembers'),
      where('organizationId', '==', organizationId),
      where('userId', '==', userId)
    );
    
    const membersSnapshot = await getDocs(membersQuery);
    return !membersSnapshot.empty;
  } catch (error) {
    handleFirebaseError(error, 'Error checking organization membership');
    return false;
  }
}

export async function isOrganizationManager(organizationId: string, userId: string): Promise<boolean> {
  try {
    const membersQuery = query(
      collection(db, 'organizationMembers'),
      where('organizationId', '==', organizationId),
      where('userId', '==', userId),
      where('role', '==', 'manager')
    );
    
    const membersSnapshot = await getDocs(membersQuery);
    return !membersSnapshot.empty;
  } catch (error) {
    handleFirebaseError(error, 'Error checking organization manager status');
    return false;
  }
} 